var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1673 5.66663C11.6276 5.66663 12.0007 6.03972 12.0007 6.49996V14.8333C12.0007 16.214 10.8814 17.3333 9.50065 17.3333H4.50065C3.11994 17.3333 2.00065 16.214 2.00065 14.8333V6.49996C2.00065 6.03972 2.37375 5.66663 2.83398 5.66663H11.1673ZM10.334 7.33329H3.66732V14.8333C3.66732 15.2935 4.04041 15.6666 4.50065 15.6666H9.50065C9.96089 15.6666 10.334 15.2935 10.334 14.8333V7.33329ZM4.50065 1.49996C4.50065 1.03972 4.87375 0.666626 5.33398 0.666626H8.66732C9.12755 0.666626 9.50065 1.03972 9.50065 1.49996V2.33329H12.834C13.2942 2.33329 13.6673 2.70639 13.6673 3.16663C13.6673 3.62686 13.2942 3.99996 12.834 3.99996H1.16732C0.70708 3.99996 0.333984 3.62686 0.333984 3.16663C0.333984 2.70639 0.70708 2.33329 1.16732 2.33329H4.50065V1.49996Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.df484179.svg";
export { ForwardRef as ReactComponent };